import React, { useEffect, useState } from "react";
import TextInput from "../../../components/TextInput";
import SearchButton from "../../../components/SearchButton";
import RefreshButton from "../../../components/RefreshButton";
import MultiSelectInput from "../../../components/MultiSelectInput";
import { BarsArrowUpIcon } from "@heroicons/react/24/solid";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Disclosure } from "@headlessui/react";
import { useSFGetOffice } from "../OfficeSettings/hooks/useSFGetOffice";
import { useGetCarriers } from "../Carrier/hooks/useGetCarriers";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import SelectInput from "../../../components/SelectInput";
import { useStates } from "../hooks/useStates";
import {
  searchDataProdCode,
  isFranchiseFilterState,
  fromRecentActivity,
  fromRecentActivityId,
} from "./atoms/atoms";
const SubTableFilters = ({
  handleSearchInputs,
  searchProducerCodeCriteriaEntry,
  setFilterStatus,
  setResetStatus,
  setFilteredproducerCodeData,
  oldFilteredValue,
  clearFilter,
  setClearFilter,
}) => {
  const user = useRecoilValue(accountAtom);
  const [producerCode, setProducerCode] = useState("");
  const [maProducerCode, setMAProducerCode] = useState("");
  const [AcquisitionName, setAcquisitionName] = useState("");
  const [selectedCarrier, setSelectedCarrier] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  //   const [, setFromRecent] = useRecoilState(fromRecentActivity);
  //   const [, setFromRecentId] = useRecoilState(fromRecentActivityId);
  const setIsFranchiseFilter = useSetRecoilState(isFranchiseFilterState);
  const [searchInputsData, setSearchInputsData] =
    useRecoilState(searchDataProdCode);
  const [selectedFranchiseConfie, setSelectedFranchiseConfie] = useState([]);
  const { data: agenciesQuery, isLoading } = useSFGetOffice();
  const agencies =
    agenciesQuery &&
    agenciesQuery.map((resData) => ({
      label:
        resData.officeName +
        "-" +
        resData.officeCode +
        "-" +
        (resData.storeNumber !== "" ? resData.storeNumber : "0"),
      value: resData.officeCode + "-" + resData.storeNumber,
      state: resData.stateCode,
      officeName: resData.officeName + "-" + resData.officeCode,
    }));
  const { data: stateQuery } = useStates();
  const states =
    stateQuery &&
    stateQuery?.map((data) => {
      return { label: data.state, value: data.state };
    });
  const { data: carriersQuery } = useGetCarriers();
  const carriers =
    carriersQuery &&
    carriersQuery
      .filter((x) => x.isActive)
      .map((resData) => ({
        label: resData.carrierName,
        value: resData.masterCarrierId,
      }));

  const refreshProducerCode = () => {
    setFilterStatus(false);
    setProducerCode("");
    setMAProducerCode("");
    setAcquisitionName("");
    handleSearchInputs("Reset", "");
    setSelectedFranchiseConfie([]);
    setSearchInputsData({
      ...searchInputsData,
      CarrierName: [],
      OfficeName: [],
      State: [],
      ProducerCode: "",
      MAProducerCode: "",
      IsConfie: false,
      IsFranchise: false,
      AcquisitionName: "",
    });
    setSelectedCarrier([]);
    setSelectedOffice([]);
    setSelectedState([]);
    setFilteredproducerCodeData([]);
    oldFilteredValue.State = [];
    oldFilteredValue.Carrier = [];
    oldFilteredValue.Offices = [];
    oldFilteredValue.ProducerCode = "";
    oldFilteredValue.MAProducerCode = "";
    oldFilteredValue.AcquisitionName = "";
    // setFromRecent(false);
    // setFromRecentId(null);
  };

  useEffect(() => {
    if (clearFilter) {
      refreshProducerCode();
    }
    setClearFilter(false);
  }, []);
  //   const handleMultiCarriersSelect = (checkedCarrier) => {
  //     var carrierList = [];
  //     checkedCarrier.map((x) => {
  //       carrierList.push(x.label);
  //     });
  //     handleSearchInputs("CarrierName", carrierList);
  //     setSelectedCarrier(checkedCarrier);
  //     oldFilteredValue.Carrier = checkedCarrier;
  //   };
  const handleSelection = (checkedValue, fieldName) => {
    if (fieldName === "ProducerCode") {
      oldFilteredValue.ProducerCode = checkedValue;
    }
    if (fieldName === "MAProducerCode") {
      oldFilteredValue.MAProducerCode = checkedValue;
    }
    if (fieldName === "AcquisitionName") {
      oldFilteredValue.AcquisitionName = checkedValue;
    }
  };
  const franchiseORConfie = [
    { label: "Confie", value: 1 },
    { label: "Franchise", value: 2 },
  ];
  const handleMultiOfficesSelect = (checkedOffice) => {
    var officeList = [];
    checkedOffice.map((x) => {
      officeList.push(x.officeName);
    });
    handleSearchInputs("OfficeName", officeList);
    setSelectedOffice(checkedOffice);
    oldFilteredValue.Offices = checkedOffice;
  };

  const handleSelectMultiStates = (checkedStates) => {
    var stateList = [];
    checkedStates.map((x) => {
      stateList.push(x.label);
    });
    handleSearchInputs("State", stateList);
    setSelectedState(checkedStates);
    oldFilteredValue.State = checkedStates;
  };
  const handleFranchiseConfieSelect = (selected) => {
    setSelectedFranchiseConfie(selected);
    if (selected) {
      if (selected.value === 2) {
        handleSearchInputs("IsFranchise", true);
      } else {
        handleSearchInputs("IsFranchise", false);
      }
      if (selected.value === 1) {
        handleSearchInputs("IsConfie", true);
      } else {
        handleSearchInputs("IsConfie", false);
      }
    } else {
      handleSearchInputs("IsFranchise", false);
      handleSearchInputs("IsConfie", false);
    }
  };

  return (
    <div className="pl-4 space-y-2 ">
      <div>
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full space-y-3 sm:w-40 md:w-40 lg:w-full">
        <div>
          <Disclosure defaultOpen>
            {({ open }) => (
              <>
                <Disclosure.Button className="sm:px-2 flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span>Producer Code Details</span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="w-full">
                    <div className="flex flex-col text-xs gap-y-2 p-3 sm:px-2 md:px-3 -mt-2">
                      {user.isFranchise && user.isNonFranchise ? (
                        <div className="w-full">
                          <label className="block font-medium text-gray-700 mb-2">
                            Franchise/Confie
                          </label>
                          <SelectInput
                            options={franchiseORConfie}
                            value={selectedFranchiseConfie}
                            onChange={(options) => {
                              handleFranchiseConfieSelect(options);
                              setIsFranchiseFilter(true);
                            }}
                          />
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          States
                        </label>

                        <MultiSelectInput
                          //options={getUnique(carriers, "label")}
                          options={states?.filter(
                            (v, i, a) =>
                              a.findIndex(
                                (t) =>
                                  t.label === v.label && t.value === v.value
                              ) === i
                          )}
                          //value={searchCarriers}
                          onChange={setResetStatus(false)}
                          value={
                            oldFilteredValue.State
                              ? oldFilteredValue.State
                              : selectedState
                          }
                          handleMultiSelect={handleSelectMultiStates}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Offices
                        </label>

                        <MultiSelectInput
                          isDisabled={isLoading}
                          // place
                          options={agencies?.filter(
                            (v, i, a) =>
                              a.findIndex(
                                (t) =>
                                  t.label === v.label && t.value === v.value
                              ) === i
                          )}
                          //value={searchCarriers}
                          onChange={setResetStatus(false)}
                          className="sm:w-40 md:w-40 lg:w-40"
                          value={
                            oldFilteredValue.Offices
                              ? oldFilteredValue.Offices
                              : selectedOffice
                          }
                          handleMultiSelect={handleMultiOfficesSelect}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          {"Producer Code"}
                        </label>

                        <TextInput
                          name="ProducerCode"
                          value={
                            oldFilteredValue.ProducerCode
                              ? oldFilteredValue.ProducerCode
                              : producerCode
                          }
                          onChange={(e) => {
                            setProducerCode(e.target.value);
                            handleSearchInputs(
                              //"EditProducerCode",
                              "ProducerCode",
                              e.target.value
                            );
                            handleSelection(e.target.value, "ProducerCode");
                          }}
                          className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          {"M&A Producer Code"}
                        </label>

                        <TextInput
                          name="MAProducerCode"
                          value={
                            oldFilteredValue.MAProducerCode
                              ? oldFilteredValue.MAProducerCode
                              : maProducerCode
                          }
                          onChange={(e) => {
                            handleSelection(e.target.value, "MAProducerCode");
                            setMAProducerCode(e.target.value);
                            handleSearchInputs(
                              //"EditProducerCode",
                              "MAProducerCode",
                              e.target.value
                            );
                          }}
                          className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          {"Acquisition Name"}
                        </label>

                        <TextInput
                          name="acquisitionName"
                          value={
                            oldFilteredValue.acquisitionName
                              ? oldFilteredValue.acquisitionName
                              : AcquisitionName
                          }
                          onChange={(e) => {
                            handleSelection(e.target.value, "AcquisitionName");
                            setAcquisitionName(e.target.value);
                            handleSearchInputs(
                              //"EditProducerCode",
                              "AcquisitionName",
                              e.target.value
                            );
                          }}
                          className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                        />
                      </div>
                      <div className="place-self-center">
                        <div className="flex flex-row gap-3 justify-center m-3">
                          <SearchButton
                            buttonValue="Search"
                            onClick={() => {
                              searchProducerCodeCriteriaEntry();
                            }}
                          />
                          <RefreshButton
                            onClick={() => {
                              refreshProducerCode();
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>{" "}
    </div>
  );
};

export default SubTableFilters;
